import React from 'react';
import { Paper, Grid, TextField, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const CustomersFilters = ({
  tabValue,
  // Filter values
  filterInvoice,
  setFilterInvoice,
  filterJobNo,
  setFilterJobNo,
  filterProjectName,
  setFilterProjectName,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  // Reset function
  resetFilters,
}) => {
  const { t } = useTranslation('navigation');

  const hasActiveFilters = filterInvoice || filterJobNo || filterProjectName || startDate || endDate;

  return (
    <Paper 
      className='p-16 mb-0' 
      sx={{ 
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        width: '100%',
        borderRadius: '4px'
      }}
    >
      <div className='flex justify-between items-center mb-16'>
        <Typography variant='h6' className='font-600'>
          {t('FILTERS')}
        </Typography>
        {hasActiveFilters && (
          <Button
            variant='contained'
            size='small'
            onClick={resetFilters}
            sx={{
              backgroundColor: '#FFC107',
              color: 'black',
              '&:hover': {
                backgroundColor: '#FFB300',
              },
            }}
          >
            {t('CLEAR_FILTERS')}
          </Button>
        )}
      </div>
      
      <Grid container spacing={2}>
        {/* Invoice Number Filter - text field: filter by typed value, no dropdown */}
        <Grid item xs={12} sm={6} md={2.4}>
          <TextField
            fullWidth
            size='small'
            label={t('INVOICE_NO')}
            placeholder={t('SEARCH')}
            value={filterInvoice || ''}
            onChange={(e) => setFilterInvoice(e.target.value)}
          />
        </Grid>

        {/* Job Number Filter - Only for invoices tabs */}
        {(tabValue === 0 || tabValue === 1 || tabValue === 3 || tabValue === 4) && (
          <Grid item xs={12} sm={6} md={2.4}>
            <TextField
              fullWidth
              size='small'
              label={t('JOB_NO')}
              placeholder={t('SEARCH')}
              value={filterJobNo || ''}
              onChange={(e) => setFilterJobNo(e.target.value)}
            />
          </Grid>
        )}

        {/* Project Name Filter - Only for invoices tabs */}
        {(tabValue === 0 || tabValue === 1) && (
          <Grid item xs={12} sm={6} md={2.4}>
            <TextField
              fullWidth
              size='small'
              label={t('PROJECT_NAME')}
              placeholder={t('SEARCH')}
              value={filterProjectName || ''}
              onChange={(e) => setFilterProjectName(e.target.value)}
            />
          </Grid>
        )}

        {/* Start Date */}
        <Grid item xs={12} sm={6} md={2.4}>
          <TextField
            fullWidth
            size='small'
            type='date'
            label={t('START_DATE')}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{ sx: { paddingTop: '2.5px !important', paddingBottom: '2.5px !important' } }}
          />
        </Grid>

        {/* End Date */}
        <Grid item xs={12} sm={6} md={2.4}>
          <TextField
            fullWidth
            size='small'
            type='date'
            label={t('END_DATE')}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{ sx: { paddingTop: '2.5px !important', paddingBottom: '2.5px !important' } }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default CustomersFilters;
